export type ModelContextTool = {
    name: string;
    description: string;
    inputSchema: Record<string, unknown>;
    annotations: { readOnlyHint: true };
    execute: (input: unknown) => Promise<unknown>;
};

export type ModelContext = {
    registerTool: (tool: ModelContextTool, options: { signal: AbortSignal }) => Promise<void>;
};

export function registerWebMcpTools(context: ModelContext, tools: ModelContextTool[]) {
    const controller = new AbortController();
    for (const tool of tools) {
        void context.registerTool(tool, { signal: controller.signal }).catch(error => {
            if (!controller.signal.aborted) {
                console.warn('[webmcp] registerTool failed:', tool.name, error);
            }
        });
    }

    return () => controller.abort();
}
